import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-white" data-id="element-58">
      <div className="max-w-4xl mx-auto" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-violet-50 border-2 border-violet-200 rounded-2xl p-8 md:p-12 text-center" data-id="element-60">
          <div className="flex justify-center mb-6" data-id="element-61">
            <div className="w-20 h-20 bg-violet-600 rounded-full flex items-center justify-center" data-id="element-62">
              <ShieldCheckIcon className="w-12 h-12 text-white" data-id="element-63" />
            </div>
          </div>

          <h3 className="font-playfair text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-64">
            Garantía "Sal con tu Página o no Pagas"
          </h3>

          <p className="text-xl text-gray-800 leading-relaxed max-w-2xl mx-auto" data-id="element-65">
            Si al terminar NO has construido y publicado una página que te gusta
            — te devuelvo el 100%. Sin preguntas.
          </p>
        </motion.div>
      </div>
    </section>;
}